import { AdminScripts } from '@Containers/Scripts';

const AdminScriptsPage: React.FunctionComponent = (): JSX.Element => (
  <AdminScripts />
);

export default AdminScriptsPage;
